import baseline from "./scoreBaseline.json";

// Score bands — must stay in sync with SCORE_BANDS in backend/server.py.
// Percentile labels come from scoreBaseline.json (rebuild with scripts/build_score_baseline.py).
export const SCORE_BANDS = [
  { min: 80, label: "Top 2% - Category Leader", color: "#10b981", emoji: "🏆", description: "Category-leading GTM clarity" },
  { min: 70, label: "Top 15% - Strong Foundation", color: "#22c55e", emoji: "💪", description: "Solid fundamentals with room for optimization" },
  { min: 60, label: "Top 40% - Above Average", color: "#84cc16", emoji: "📈", description: "Good potential with execution gaps" },
  { min: 50, label: "Average", color: "#eab308", emoji: "📊", description: "Typical of the companies we scan" },
  { min: 40, label: "Below Average", color: "#f97316", emoji: "⚠️", description: "Significant gaps requiring attention" },
  { min: 0, label: "Bottom 15% - Needs Work", color: "#ef4444", emoji: "🚨", description: "Critical gaps across GTM fundamentals" },
];

export const SCORE_BASELINE = baseline;

export function getScoreBand(score) {
  const s = score || 0;
  return SCORE_BANDS.find((b) => s >= b.min);
}

// e.g. "Higher than 72% of the 832 companies we've scanned"
export function getPercentileText(score) {
  const s = Math.max(0, Math.min(100, Math.round(score || 0)));
  const pct = Math.min(99, Math.floor(baseline.below_pct[s]));
  return `Higher than ${pct}% of the ${baseline.companies.toLocaleString()} companies we've scanned`;
}
